import React from "react";
import PropTypes from "prop-types";
// Material imports
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
// Modern imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
// icons imports
import CloseIcon from "@limitless/icons/Close";
const CustomChip = styled(Chip)(({
  theme
}) => ({
  backgroundColor: theme.palette.background.elevation1,
  boxShadow: theme.palette.mode === "light" ? "0px 2px 2px -0px rgba(0,0,0,0.15)" : "0px 2px 2px 0px rgba(0,0,0,0.4)",
  borderRadius: "16px",
  height: "auto",
  maxWidth: "110px",
  "& .MuiChip-deleteIcon": {
    color: theme.palette.primary.main,
    margin: "6px 5px 0px 0px",
    fontSize: "16px",
    "&:hover": {
      color: theme.palette.primary.main
    }
  },
  "& .MuiChip-label": {
    paddingLeft: 0,
    display: "block",
    whiteSpace: "normal",
    maxWidth: "80px",
    textAlign: "center",
    lineHeight: "12px"
  }
}));
const FilterChip = ({
  label,
  labelVariant = "caption",
  onDelete,
  avatarComponent
}) => {
  return /*#__PURE__*/React.createElement(CustomChip, {
    label: /*#__PURE__*/React.createElement(Grid, {
      display: "flex",
      alignItems: "center"
    }, avatarComponent, /*#__PURE__*/React.createElement(Typography, {
      variant: labelVariant,
      color: "textPrimary",
      paddingLeft: 1,
      sx: {
        lineHeight: "12px"
      }
    }, label)),
    deleteIcon: /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        color: theme => theme.palette.primary.main
      }
    }),
    onDelete: onDelete
  });
};
export default FilterChip;
FilterChip.propTypes = {
  label: PropTypes.string.isRequired,
  labelVariant: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  avatarComponent: PropTypes.node.isRequired
};